import { all, fork } from "redux-saga/effects";
//layout
import LayoutSaga from "./layouts/saga";
//Auth
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";

//Client
import clientSaga from "./client/saga";
//Admin
import adminSaga from "./admin/saga";
//Chauffeur
import chauffeurSaga from "./chauffeur/saga";
//Livreur
import livreurSaga from "./livreur/saga";
// Organisateur
import organisateurSaga from "./organisateur/saga";
// Paie des organisateurs
import payOrganizerSaga from "./pay-organizer/saga";
// Evenement
import evenementSaga from "./evenement/saga";
// Code promo
import codePromoSaga from "./code-promo/saga";
// Parainage
import parainageSaga from "./parainage/saga";
// Alertes
import alerteSaga from "./alertes/saga";

import historiqueSaga from "./historique/saga";

import factureSaga from "./facture/saga";

import majorationSaga from "./majoration/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(clientSaga),
    fork(adminSaga),
    fork(chauffeurSaga),
    fork(organisateurSaga),
    fork(payOrganizerSaga),
    fork(historiqueSaga),
    fork(factureSaga),
    fork(majorationSaga),
    fork(livreurSaga),
    fork(evenementSaga),
    fork(codePromoSaga),
    fork(parainageSaga),
    fork(alerteSaga),
  ]);
}
